export default {"src":"/_next/static/media/billing.e3f8d788.svg","height":160,"width":160};